import React, { useEffect, useState } from 'react';
import { IonPage, IonContent } from '@ionic/react';
import { useHistory, useLocation } from 'react-router-dom';
import { api } from '../../services/api';

const VerifyEmailPage: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const [state, setState] = useState<'verifying' | 'success' | 'error'>('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = new URLSearchParams(location.search).get('token') || '';
    if (!token) {
      setState('error');
      setMessage('This link is missing its verification token.');
      return;
    }
    (async () => {
      try {
        const res = await api.post('/auth/verify-email', { token });
        setState('success');
        setMessage(res.data?.message || 'Email verified.');
      } catch (err: any) {
        setState('error');
        setMessage(err?.response?.data?.error || 'Verification link is invalid or expired.');
      }
    })();
  }, [location.search]);

  return (
    <IonPage>
      <IonContent>
        <div style={{ minHeight: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f1923', color: '#f5f3ee', padding: 24 }}>
          <div style={{ maxWidth: 420, textAlign: 'center', fontFamily: 'Manrope, system-ui, sans-serif' }}>
            <img src="/icon-nobg.png" alt="FamHearth" width={72} height={72} style={{ marginBottom: 16 }} />
            <h1 style={{ fontFamily: "'Instrument Serif', Georgia, serif", fontStyle: 'italic', fontSize: 36, margin: '0 0 12px' }}>
              {state === 'verifying' && 'Verifying…'}
              {state === 'success' && 'You\'re in.'}
              {state === 'error' && 'Something went wrong'}
            </h1>
            <p style={{ margin: '0 0 24px', color: 'rgba(245,243,238,0.75)' }}>{message}</p>
            {state !== 'verifying' && (
              <button
                onClick={() => history.replace('/login')}
                style={{ background: '#c5512d', color: '#fff', border: 'none', padding: '12px 22px', borderRadius: 10, fontWeight: 700, cursor: 'pointer' }}
              >
                Continue to sign in
              </button>
            )}
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default VerifyEmailPage;
